import React from "react";
import { Box, useTheme, Typography } from "@mui/material";
import { ModalComponent } from "components/ModalComponent";
import errorIcon from "assets/images/errorIcon.png";

export type Props = {
  open: boolean;
  handleClose: () => void;
  title: string;
  subtitle: string;
  infoTitle?: string;
};

export const ErrorModal = ({
  open,
  handleClose,
  title,
  subtitle,
  infoTitle,
}: Props) => {
  const theme = useTheme();

  return (
    <ModalComponent
      open={open}
      closable
      handleClose={handleClose}
      boxStyles={{
        width: "460px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            mb: "20px",
          }}
        >
          <img src={errorIcon} alt="error" />
        </Box>
        <Box
          sx={{
            mb: "25px",
          }}
        >
          <Typography variant="h4" sx={{ textAlign: "center", mb: "6px" }}>
            {title}
          </Typography>
          <Typography variant="h5" sx={{ textAlign: "center" }}>
            {subtitle}
          </Typography>
        </Box>
        {infoTitle && (
          <a
            href={`mailto:${infoTitle}`}
            style={{
              marginBottom: "40px",
              color: theme.palette.secondary.main,
              fontWeight: 600,
            }}
          >
            {infoTitle}
          </a>
        )}
      </Box>
      <Box
        sx={{
          width: "100%",
          height: "8px",
          bgcolor: theme.palette.secondary.main,
        }}
      />
    </ModalComponent>
  );
};
